import Axios from "../../utils/axios";

export const createPrayerRequest = async (payload) => {
  const response = await Axios.post("/prayers/request", payload);
  return response.data;
};
export const fetchMyPrayerRequests = async () => {
    const response = await Axios.post("/prayers/myprayerrequests");
    return response.data;
  };

  export const createPrayerResponse = async (payload) => {
    const response = await Axios.post("/prayers/response/save", payload);
    return response.data;
  };
  
  export const updatePrayerResponse = async (payload) => {
    const response = await Axios.post("/prayers/response/update", payload);
    return response.data;
  };
  
  export const deletePrayerResponse = async (payload) => {
    const response = await Axios.post("/prayers/response/delete", payload);
    return response.data;
  };
  
  export const readPrayerResponses = async (payload) => {
    const response = await Axios.post("/prayers/response/read", payload);
    return response.data;
  };

  // PrayerAPI.js
export const fetchMyPrayersList = async (payload) => {
  const response = await Axios.post("/prayers/myprayerslist", payload);
  return response.data;
};

export const fetchChurchFollowersPrayers = async (payload) => {
  const response = await Axios.post(
    "/churches/followers/prayers",
    payload
  );
  return response.data;
};
export const fetchChannelFollowersPrayers = async (payload) => {
  const response = await Axios.post(
    "/channels/followers/prayers",
    payload
  );
  return response.data;
};

export const fetchMinistriesFollowersPrayers = async (payload) => {
  const response = await Axios.post(
    "/ministries/followers/prayers",
    payload
  );
  return response.data;
};
